<template>
    <div>
        <div class="Keikakumeisai_HanbaisakiCostItem" :title="Tooltip"><div>{{this.CostName}}</div> <div>{{ this.$FormatCurrency(this.Cost) }}</div></div>
    </div>
</template>

<script>
export default
{
    props:{
        CostName: String,
        Cost: Number,
        Tooltip: String,
    }
}
</script>